export default (id: string) => id.split('/Product/')[1]
